<template>
  <article :class="{ 'out-of-stock' : product.out_of_stock }">
    <div class="image">
      <a :href="url">
        <img :src="image" :alt="product.title">
      </a>
    </div>

    <div class="content">
      <h3>
        <a :href="url">{{ title }}</a>
      </h3>

      <p v-if="!product.poa" class="price">
        <span>$</span>{{ modFormatAmount(product.price) }}
      </p>
      <p v-else class="price">
        {{ product.poa_text }}
      </p>
      <p class="sku">{{ product.sku }}&nbsp;</p>

      <div class="buttons">

        <a
          v-if="!product.isAddToCart"
          :href="url"
          class="button"
        >
          ENQUIRE
        </a>

        <button
          v-else
          class="button"
          @click="addToCart()"
        >
          ADD TO CART
        </button>

      </div>
    </div>

  </article>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      required: true,
    },
  },

  computed: {
    // since upsell and products have different ways of getting the format, we use this computed variable
    image () {
      const product = this.product

      if (product.images) {
        return product.images[0].thumbnail
      }

      return product.image
    },

    title () {
      const title = this.product.title
      const maxChars = 37
      return title.length > maxChars ? title.substr(0, maxChars) + '...' : title
    },

    url () {
      return this.product.url || '/products/' + this.product.slug
    },
  },

  methods: {
    addToCart () {
      this.$store.commit('setLoading', true)

      window.axios.post('/api/cart', { id: this.product.id, qty: 1})
        .then((res) => {
          console.log(res)
          this.$store.commit('setLoading', false)

          if (res.status === 200) {
            this.$store.commit('setCart', res.data)
            this.$store.commit('setToastMessage', {
              open: true,
              type: 'success',
              message: 'This item was added to your cart.'
            })
          } else {
            this.$store.commit('setToastMessage', {
              open: true,
              type: 'fail',
              message: 'Something went wrong. Please try again.'
            })
          }
        })
        .catch((error) => {
          this.$store.commit('setLoading', false)
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>' + error.response.data.message + '</p>'
          })
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import "../../../sass/core/variables.scss";

article {
  background: white;
  border: 1px solid #d7d7d7;

  .image {
    margin: 0;

    img {
      width: 100%;
      margin: 0 0 6px;
    }
  }

  .content {
    width: 100%;
    padding: 20px;

    h3 {
      margin: 0 0 12px;
      min-height: 34px;

      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.1px;
      line-height: 18px;
      // text-transform: uppercase;
      color: $color-1;

      a {
        font-size: inherit;
        font-weight: inherit;
        letter-spacing: inherit;
        line-height: inherit;
        color: inherit;
      }
    }

    p.price {
      width: 100%;
      margin: 0 0 26px;

      font-size: 22px;
      font-weight: 700;
      letter-spacing: 0.2px;

      span {
        display: inline-block;
        vertical-align: text-bottom;

        font-size: 13px;
      }
    }

    p.sku {
      margin-bottom: 8px;

      font-size: 12px;
      font-weight: 400;
      letter-spacing: 0.2px;
      line-height: 16px;
      color: $color-2;
    }
  }

  .buttons {
    .button {
      width: 100%;
      min-width: 100%;
      padding: 5px 0px;
    }
  }
}

article:hover {
  border-color: $color-1;
}
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-product/components/Item.vue